const baseUrl = process.env.VUE_APP_BASE_URL;
const append = process.env.VUE_APP_FB_AUTH_SUFFIX;

const FB = {
  appId: "420729019050953",
  responseType: "code",
  redirect: `${baseUrl}/login/fb_oauth_cb/${append}`
};

const fbLink = "https://www.facebook.com/v9.0/dialog/oauth";

export const oauthLink = `${fbLink}?client_id=${FB.appId}&response_type=${FB.responseType}&redirect_uri=${FB.redirect}`;
